import { Cart } from 'models/cart'

export const addCartToBugsnag = function (cart: Cart) {
  if (window['bugsnagClient'])
    window['bugsnagClient'].metaData = { cart: cart.toJS() }
}
